import selectors from '../globals/selectors';
import addOnlineRegistrationModal from '../components/onlineRegistrationModal';
import addMobileNav from '../components/mobileNav';
import modalCalc from '../components/modalCalc';
import addOrderHistory from '../components/orderHistoryModal';
import addSelect from '../components/select';
import addSearch from '../components/search';
import SearchProducts from '../services/SearchProducts';

export default (logic = () => {}) => {
	document.addEventListener('DOMContentLoaded', () => {
		// eslint-disable-next-line no-unused-vars
		const registrationModal = addOnlineRegistrationModal();
		addMobileNav();
		addSelect(selectors.footer.citySelect);
		modalCalc(registrationModal);
		addOrderHistory();

		SearchProducts.fetch().then((products) => {
			addSearch(selectors.header.search, {
				list: products,
			});
		});

		//  dropDown

		const sortDropDown = document.querySelectorAll(
			'.content-top__left-dropdown'
		);

		sortDropDown.forEach((dropdown) => {
			dropdown.addEventListener('click', (e) => {
				e.isCatalogDropDown = true;
				const activeList = dropdown.querySelector('.content-top__list');
				if (!activeList.classList.contains('dropdown--active')) {
					activeList.classList.add('dropdown--active');
				} else {
					activeList.classList.remove('dropdown--active');
				}
				window.addEventListener('click', (e) => {
					if (!e.isCatalogDropDown) {
						activeList.classList.remove('dropdown--active');
					}
				});

				const items = Array.from(
					dropdown.querySelector('.content-top__list').children
				);
				items.forEach((item) => {
					item.addEventListener('click', (e) => {
						const activeItem = dropdown.querySelector(
							'.content-top__sort--active'
						);
						const currentText = activeItem.textContent;
						if (activeItem === e.currentTarget) {
							return;
						}
						items[0].textContent = e.currentTarget.textContent;
						activeItem.textContent = e.currentTarget.textContent;
						e.currentTarget.textContent = currentText;
					});
				});
			});
		});

		// cities dropDown

		const cityBtn = document.querySelector('.header-top__left-link--cities');
		const cityDropDown = document.querySelector('.cities__list');
		const cities = Array.from(cityDropDown.children);
		const currentCity = cityBtn.querySelector('.header-top__left-city');

		cities.forEach((city) => {
			city.addEventListener('click', (e) => {
				const activeCity = document.querySelector('.cities__active-city');
				if (e.target === activeCity) {
					return;
				}
				activeCity.classList.remove('cities__active-city');
				e.currentTarget.classList.add('cities__active-city');
				currentCity.textContent = e.currentTarget.textContent;
				checkCurrentCity();
				cityBtn.click();
			});
		});

		let cityFl = false;

		cityBtn.addEventListener('click', (e) => cityBtnToggle(e));

		function cityBtnToggle(e) {
			e.stopPropagation();
			e.preventDefault();
			const triangle = e.currentTarget.querySelector(
				'.header-top__left-triangle'
			);
			e._isCityDropDown = true;
			const stationDropDown = document.querySelector('.stations__list');

			if (stationFl) stationBtn.click();

			if (cityFl) {
				cityDropDown.classList.add('hidden');
				triangle.classList.remove('triangle--rotate');
				cityFl = false;
			} else {
				cityFl = true;
				triangle.classList.add('triangle--rotate');
				cityDropDown.classList.remove('hidden');
			}
			// onClickClose();
		}

		const cityChoosePopup = document.querySelector('#city-chooser-popup');
		const correctCity = document.querySelector('#correct-city');
		const incorrectCity = document.querySelector('#incorrect-city');

		if (
			!document.cookie
				.split(';')
				.some((item) => item.includes('city_is_chosen=true'))
		) {
			cityChoosePopup.classList.add('active');
		}

		correctCity.addEventListener('click', (e) => {
			e.preventDefault();
			cityChoosePopup.classList.remove('active');
			document.cookie = 'city_is_chosen=true; samesite=lax;';
		});

		incorrectCity.addEventListener('click', (e) => {
			e.preventDefault();
			cityChoosePopup.classList.remove('active');
			setTimeout(() => {
				cityBtn.click();
			}, 0);
		});

		// station dropDown

		const stationBtn = document.querySelector(
			'.header-top__left-link--addresses'
		);
		const stationDropDown = document.querySelector('.stations__list');

		const stations = Array.from(stationDropDown.children);
		const currentStation = stationBtn.querySelector(
			'.header-top__left-station'
		);

		function checkCurrentCity () {
			if (currentCity.textContent !== 'Санкт-Петербург') {
				stationBtn.style.visibility = 'hidden';
			} else {
				stationBtn.style.visibility = 'visible';
			}
		}

		stations.forEach((station) => {
			station.addEventListener('click', (e) => {
				const activeStation = document.querySelector(
					'.stations__active-station'
				);
				if (activeStation && e.target === activeStation) {
					return;
				}
				if (activeStation) {
					activeStation.classList.remove('stations__active-station');
				}
				e.currentTarget.classList.add('stations__active-station');
				currentStation.textContent = e.currentTarget.textContent;
				stationBtn.click();
			});
		});

		let stationFl = false;

		stationBtn.addEventListener('click', (e) => {
			e.stopPropagation();
			e.preventDefault();

			e._isStationDropDown = true;
			const triangle = e.currentTarget.querySelector(
				'.header-top__left-triangle'
			);

			if (cityFl) cityBtn.click();

			if (stationFl) {
				stationDropDown.classList.add('hidden');
				triangle.classList.remove('triangle--rotate');
				stationFl = false;
			} else {
				triangle.classList.add('triangle--rotate');
				stationDropDown.classList.remove('hidden');
				stationFl = true;
			}
			// onClickClose(e)
		});

		window.addEventListener('click', (e) => {
			if (!cityDropDown.classList.contains('hidden')) {
				cityBtn.click()
			}
			if (!stationDropDown.classList.contains('hidden')) {
				stationBtn.click()
			}
		})

		logic();
	});
};
